import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { UserManagerService } from '../shared/providers/user-manager.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../shared/providers/validation.service';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { DataTableDirective } from 'angular-datatables';
import { DataTablesResponse } from '../shared/models/datatables-response';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { LoaderService } from '../shared/providers/loader.service';
import { UserExchangeModel } from '../shared/models/UserExchangesModel';
import { BrokerSelecttionModel } from '../shared/models/SavePropertyInputModel';
import { SelectedIdInputmodel } from '../shared/models/SelectedIdInputmodel';
import { SavePropertyContactUserInput } from '../shared/models/SavePropertyContactUserInput';
import { PropertyManagementService } from '../shared/providers/property-management.service';
import { UserAssociatedProperties } from '../shared/models/UserAssociatedProperties';
import { IUser } from '../shared/models/user';
import { IUserDetails } from '../shared/models/UserDetailsOutputModel';
import { UserRole } from '../shared/enum/enum';
import { ToastService } from '../shared/providers/toast.service';
import { PermissionService } from '../shared/providers/permission.service';
import { Actions, Modules } from '../shared/enum/enum';

@Component({
  selector: 'user-exchanges',
  templateUrl: './user-exchanges.component.html',

})

export class UserExchangesComponent {
  constructor(private _userManagerService: UserManagerService, public permissionService: PermissionService, private _toastService: ToastService, private activatedRoute: ActivatedRoute, private Loader: LoaderService, private http: HttpClient, public authService: AuthenticationService, private router: Router, public _validationService: ValidationService, private _propertyManagementService: PropertyManagementService) {

  }
  user: any;
  @Input() CurrentUser = {} as IUser;
  @Input() principalDetails = {} as IUserDetails;
  Modules = Modules;
  Actions = Actions;
  protected readonly BASE_URL: string = environment.base_url;
  table: DataTableDirective;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  dtoptionsExchange = {};
  DDColumns = [];
  propertyList: UserExchangeModel[] = [];
  selectAll = false;
  IsEditClicked = false;
  brokers: BrokerSelecttionModel[] = [];
  selectedInputModel: SelectedIdInputmodel[] = [];
  propertyContactInput = {} as SavePropertyContactUserInput;
  selectedLiveListings: UserExchangeModel[] = [];
  IsEmployee = false;
  IsDataProcessing = false;
  bulkBrokerId: number = 0;
  userRole = UserRole;
  ngOnInit() {
    this.user = this.authService.user;
    if (this.principalDetails.UserRoleId == this.userRole.Admin || this.principalDetails.UserRoleId == this.userRole.Broker || this.principalDetails.UserRoleId == this.userRole.SuperAdmin) {
      this.IsEmployee = true;
      this.getExchanges();
      this.bindBrokers();
    }
    else {
      this.IsEmployee = false;
      this.IsEditClicked = false;
      this.getExchanges();
    }

  }

  onBrokerClick() {
    if (this.propertyList.filter(f => f.IsSelected).length <= 0) {
      this.bulkBrokerId = 0;
    }
  }

  bindBrokers() {
    this._propertyManagementService.getBrokers(0).subscribe(response => {
      if (response != null && response.length > 0) {
        response = response.filter(f => f.Id != this.CurrentUser.Id);
      }
      this.brokers = response;
    });
  }

  onBulkBrokerChange(event: any) {
    if (this.propertyList.filter(f => f.IsSelected).length <= 0) {
      // this.bulkBrokerId = 0;
      this._toastService.addToast({ title: 'Error', msg: "Please select the Exchange.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
    }
    else {
      this.selectedLiveListings = [];
      this.propertyList.filter(f => f.IsSelected).forEach(item => {
        item.BrokerId = this.bulkBrokerId;
      });
      this.selectedLiveListings = this.propertyList.filter(f => f.IsSelected);
    }

  }
  getExchanges() {

    this.DDColumns = [
      { data: 'IsSelected' },
      { data: 'IsSelected' },
      { data: 'Id' },
      { data: 'PrincipalName' },
      { data: 'Offers' },
      { data: 'Id' }
    ];

    const that = this;
    this.dtoptionsExchange = {
      pagingType: 'full_numbers',
      "pageLength": 20,
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "order": [[2, "desc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsDataProcessing = true;
        dataTablesParameters.Extra_param = {
          UserId: that.CurrentUser.Id,
        }
        const httpHeader = this._validationService.GetAuthHeader();
        that.http.post<DataTablesResponse>(
          this.BASE_URL + '/property/GetAllUserExchanges', dataTablesParameters, httpHeader).subscribe(resp => {
            if (resp != null) {
              that.propertyList = resp.data ? resp.data : [];
              this.Loader.display(false);
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data == null || resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            this.IsDataProcessing = false;
          });

        this.Loader.display(false);
      },
      columns: this.DDColumns
    };
  }

  onSelectAll(event) {
    if (event.target.checked) {
      this.selectOrUnSelectAll(true);
    }
    else {
      this.UnSelectAll(false);
    }
  }

  selectOrUnSelectAll(trueOrfalse) {
    this.propertyList.forEach(item => {
      item.IsSelected = trueOrfalse;
      if (trueOrfalse) {
        if (this.selectedLiveListings.findIndex(x => x.Id == item.Id) < 0) {
          this.selectedLiveListings.push(item);
        }
      }
      else {
        this.selectedLiveListings.splice(this.selectedLiveListings.findIndex(x => x.Id == item.Id), 1);
      }
    });
    if (!trueOrfalse) {
      this.selectAll = false;
    }
  }

  UnSelectAll(trueOrfalse) {
    this.propertyList.forEach(item => {
      item.IsSelected = trueOrfalse;
      item.BrokerId = 0;
    });
    this.selectedLiveListings = [];
    if (this.propertyList.filter(f => f.IsSelected).length <= 0) {
      this.bulkBrokerId = 0;
    }
    if (!trueOrfalse) {
      this.selectAll = false;
    }
  }

  editUserExchanges() {
    this.IsEditClicked = true;
  }

  clearSelectedContact() {
    this.IsEditClicked = false;
  }

  onCheckboxChange(event, Id) {
    if (event.target.checked) {
      let prop = this.propertyList.find(x => x.Id == Id);
      if (prop = null) {
        prop.IsSelected = true;
        this.selectedLiveListings.push(prop);
      }

    }
    else {
      let prop = this.propertyList.find(x => x.Id == Id);
      if (prop != null) {
        prop.IsSelected = false;
        prop.BrokerId = 0;
      }
      if (this.propertyList.filter(f => f.IsSelected).length <= 0) {
        this.bulkBrokerId = 0;
      }
      this.selectedLiveListings = this.selectedLiveListings.filter(x => x.Id !== Id);
    }
    this.autoSelectAll();
  }
  autoSelectAll() {
    if (this.propertyList.filter(x => x.IsSelected == true).length == this.propertyList.length && this.propertyList.length > 0) {
      this.selectAll = true;
    }
    else {
      this.selectAll = false;
    }
  }

  trackById(index: number, item: any): number {
    return item.Id; // or whatever unique key your property has
  }

  autoSelectProperties() {
    if (this.propertyList != null && this.propertyList.length > 0) {
      if (this.selectedLiveListings != null && this.selectedLiveListings.length > 0) {
        this.propertyList.forEach(item => {
          if (this.selectedLiveListings.findIndex(f => f.Id == item.Id) > -1) {
            let currentBroker = this.selectedLiveListings.find(f => f.Id == item.Id);
            if (currentBroker != null && currentBroker != undefined && currentBroker.BrokerId != null) {
              item.BrokerId = currentBroker.BrokerId;
            }
            item.IsSelected = true;
          }
        });
      }

      if (this.propertyList.findIndex(f => !f.IsSelected) > -1) {
        this.selectAll = false;
      }
      else {
        this.selectAll = true;
      }
    }
  }

  onBrokerChange(event: any, property: any) {
    if (event != null && event.target.value != null) {
      property.BrokerId = event.target.value;
      this.selectedLiveListings.push(property);
    }
    else {
      property.BrokerId = null;
      if (this.selectedLiveListings != null && this.selectedLiveListings.length > 0) {
        this.selectedLiveListings.splice(this.selectedLiveListings.findIndex(x => x.Id == property.Id), 1);

      }

    }
  }

  saveUserExchanges() {
    if (this.propertyList != null) {
      if (this.selectedLiveListings != null && this.selectedLiveListings.length > 0) {
        this.Loader.display(true);
        this.selectedInputModel = this.selectedLiveListings.map(o => { return { Id: o.Id, BrokerId: o.BrokerId }; });
        if (this.selectedInputModel != null && this.selectedInputModel.length > 0) {
          this.user = this.authService.user;
          this.propertyContactInput = {} as SavePropertyContactUserInput;;
          this.propertyContactInput.UserId = this.CurrentUser.Id;
          this.propertyContactInput.Type = 2;
          this.propertyContactInput.SelectedValues = this.selectedInputModel;
          this._propertyManagementService.savePropertyContactForDeleteUser(this.propertyContactInput).subscribe(response => {
            if (response) {
              this.Loader.display(false);
              this.selectedLiveListings = [];
              this.IsEditClicked = false;
              this.propertyContactInput = null;
              this.bulkBrokerId = 0;
              this.selectAll = false;
              this.propertyList = [];
              this.dtElement.dtInstance.then(x => x.draw());
              this._toastService.addToast({ title: 'Success', msg: "New Broker Added Successfully.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
            }
            else {
              this.Loader.display(false);
              this._toastService.addToast({ title: 'Error', msg: "Something went wrong.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
            }
          });
        }
        else {
          this.Loader.display(false);
          this._toastService.addToast({ title: 'Error', msg: "Something went wrong.", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        }
      }
    }
  }

  viewDetail(exguid: any) {
    //this.router.navigate(['/exchange1031-view/' + exguid]);
    this.router.navigate(['/dashboard-1031/' + exguid]);
  }

}
